<template>
  <div class="root">
    <!-- <img src="@/assets/images/logo.png" class="logo" @click="goHome"/> -->
    <full-page @after-load="afterLoad">
      <page-netease />
      <!-- <page-fullvideo /> -->
      <!-- <page-logo /> -->
      <!-- <page-overview ref="sectionOverview" @end="end"/>
      <page-intro />
      <page-structure ref="sectionStructure"/>
      <page-dialog />

      <page-picture />
      <div id="picture2" class="section" />
      <div id="picture3" class="section" />
      <div id="picture4" class="section" />

      <page-together />
      <page-join ref="sectionJoin" @openDeviceModal="moveSectionDown()"  />
      <page-share @openShareModal="showShareModal" /> -->
    </full-page>
    <!-- <device-modal v-if="showDevice"
      @close="showDeviceModal(false)"
      :count="userCount"
      ></device-modal>
    <share-modal v-if="showShare"
      :tag="selectedTag"
      :music="selectedMusic"
      ></share-modal> -->
  </div>
</template>

<script>
  import FullPage from 'vue-fullpage.js'
  import FullPageMixin from 'vue-fullpage.js/src/fullPageMixin'

  import PageNetease from '@/pages/p-netease'
  // import DeviceModal from '@/components/device-modal'
  // import ShareModal from '@/components/share-modal'

  // // Pages
  // import PageLoading from '@/pages/p-loading'
  // import PageLogo from '@/pages/p-logo'
  // import PageOverview from '@/pages/p-overview'
  // import PageIntro from '@/pages/p-intro'
  // import PageStructure from '@/pages/p-structure'
  // import PageDialog from '@/pages/p-dialog'
  // import PageCases from '@/pages/p-cases'
  // import PagePicture from '@/pages/p-picture'
  // import PageTogether from '@/pages/p-together'
  // import PageJoin from '@/pages/p-join'
  // import PageShare from '@/pages/p-share'
  // import PageFullvideo from '@/pages/p-fullvideo'

  export default {
    mixins: [FullPageMixin],
    components: {
      FullPage,
      PageNetease
      // DeviceModal,
      // ShareModal,

      // PageFullvideo,
      // PageLoading,
      // PageLogo,
      // PageOverview,
      // PageIntro,
      // PageStructure,
      // PageDialog,
      // PageCases,
      // PagePicture,
      // PageTogether,
      // PageJoin,
      // PageShare
    },
    data() {
      return {
        showDevice: false,
        showShare: false,
        userCount: 10,
        fpoptions:{
          // afterLoad: this.afterLoad
        },
        selectedTag: null,
        selectedMusic: null
      }
    },
    created() {
      // setTimeout(() => {
      //   console.log(this.moveTo(4))
      // }, 1000)
    },
    mounted() {
      // this.showShareModal(true)
      // this.$http.get('/aaa')
      //监听state
      window.addEventListener("popstate", (event) => {
        let state = event.state || {}
        let showDevice = state.showDevice || false
        let showShare = state.showShare || false
        this.toggleDeviceModal(showDevice)
        this.toggleShareModal(showShare)
      })

      this.setAllowScrolling(false)
      this.setKeyboardScrolling(false)
      // IOS10 Safari不识别meta，故需要js hack
      document.documentElement.addEventListener('touchstart', function (event) {
        if (event.touches && event.touches.length > 1) {
          event.preventDefault()
        }
      }, false)

      // 首页视频微信端自动播放
      // let that = this
      // if (window.WeixinJSBridge) {
      //     WeixinJSBridge.invoke('getNetworkType', {}, function (e) {
      //         that.$refs.sectionOverview.afterLoad()
      //     }, false);
      // } else {
      //     document.addEventListener("WeixinJSBridgeReady", function () {
      //         WeixinJSBridge.invoke('getNetworkType', {}, function (e) {
      //           that.$refs.sectionOverview.afterLoad()
      //         });
      //     }, false);
      // }

    },
    methods: {
      goHome () {
        this.moveTo(1)
      },
      end () {
        this.setAllowScrolling(true)
        this.setKeyboardScrolling(true)
      },
      showDeviceModal() {
        // pushState需要保存的是当前页面的状态,并推送到history中
        window.history.pushState({showDevice: this.showDevice}, '', './')
        this.toggleDeviceModal(true)
      },
      toggleDeviceModal( show ) {
        this.showDevice = show
        // modal状态改变时要禁用或启用 fullpage 这两个方法是mixin注入的
        this.setAllowScrolling(!show)
        this.setKeyboardScrolling(!show)
        if(!show){
          this.reBuild()
        }
      },
      showShareModal(selectedTag, selectedMusic) {
        window.history.pushState({showShare: this.showShare}, '', './')
        this.selectedTag = selectedTag
        this.selectedMusic = selectedMusic
        this.toggleShareModal(true)
      },
      toggleShareModal( show ) {
        this.showShare = show
        // modal状态改变时要禁用或启用 fullpage 这两个方法是mixin注入的
        this.setAllowScrolling(!show)
        this.setKeyboardScrolling(!show)
        if(!show){
          this.reBuild()
        }
      },
      afterLoad(origin,index) {
        // console.log(index)
        // if (index == 1) {
        //   this.$refs.sectionOverview.afterLoad()
        // }
        // if(index == 3){// structure page
        //   this.$refs.sectionStructure.afterLoad()
        // }
        // if(index == 10){
        //   this.$refs.sectionJoin.afterLoad()
        // }
      },
      // caseUp() {
      //   // 长图区域请求往上一屏滚动
      //   this.moveTo(4)
      //   this.setAllowScrolling(true)
      // },
      // caseDown() {
      //   // 长图区域请求往下一屏滚动
      //   this.moveTo(6)
      //   this.setAllowScrolling(true)
      // }
    }
  }
</script>

<style lang="postcss" scoped>
  @import "./assets/css/reset.css";
  @import "./assets/css/global.css";

  .root {
    text-align: center;

    .section {
      position: relative;
    }

    .logo {
      opacity: 0;
      position: fixed;
      top: 20px;
      right: 20px;
      width: 25px;
      height: 25px;
      z-index: 666;
    }
  }

  #picture2 {
    background: url("./assets/images/cases/2.jpg") center;
    background-size: cover;
  }

  #picture3 {
    background: url("./assets/images/cases/3.jpg") center;
    background-size: cover;
  }

  #picture4 {
    background: url("./assets/images/cases/4.jpg") center;
    background-size: cover;
  }

</style>
